///Users/igorgalkin/Desktop/collaboration_platform/frontend/src/services/questionnaireAnalyticsAPI.js

import api from './api';

const downloadExport = async (format) => {
  const endpoints = {
    csv: '/questionnaires/analytics/export/csv/',
    xlsx: '/questionnaires/analytics/export/xlsx/',
  };

  const filenames = {
    csv: 'questionnaire_analytics.csv',
    xlsx: 'questionnaire_analytics.xlsx',
  };

  if (!endpoints[format]) {
    throw new Error('Неподдерживаемый формат экспорта.');
  }

  try {
    const response = await api.get(endpoints[format], {
      responseType: 'blob',
    });

    const blob = new Blob([response.data], {
      type:
        response.headers['content-type'] ||
        'application/octet-stream',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filenames[format];

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    let message = 'Не удалось скачать файл. Попробуйте ещё раз.';
    const data = error?.response?.data;

    if (data instanceof Blob) {
      try {
        const parsed = JSON.parse(await data.text());
        message = parsed.detail || parsed.error || message;
      } catch (_) {
        // Если сервер вернул не JSON, оставляем стандартное сообщение.
      }
    } else if (data?.detail || data?.error) {
      message = data.detail || data.error;
    }

    const exportError = new Error(message);
    exportError.status = error?.response?.status;

    throw exportError;
  }
};

const questionnaireAnalyticsAPI = {
  exportCSV: () => downloadExport('csv'),
  exportXLSX: () => downloadExport('xlsx'),
};

export default questionnaireAnalyticsAPI;